import type { CustomerAddressFragment } from '@gql'

export function formatAddress(
  option: CustomerAddressFragment | undefined,
  options?: {
    multiline?: boolean
  },
) {
  if (!option) {
    return undefined
  }

  return [
    option.streetAddress1,
    option.streetAddress2,
    [option.city, option.cityArea].filter((i) => !!i).join(' - '),
    option.postalCode,
    option.countryArea?.name,
    option.country?.name,
  ]
    .map((i) => i?.trim())
    .filter(Boolean)
    .join(options?.multiline ? '\n' : ', ')
}
